module.exports = __webpack_public_path__ + "static/img/20.25cddb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/20.jpg
// module id = U44B
// module chunks = 1